import React, { Component } from 'react';
import { UserProductGroup } from '~/Api/User/ProductGroup';
import {
	FREQUENCY_DISABLED,
	FREQUENCY_IMMEDIATE,
	FREQUENCY_MONTHLY,
	FREQUENCY_WEEKLY,
} from '~/Api/User/ProductGroup/NotificationSettings';
import Heading from '~/UI/Heading/Heading';
import Icon from '~/UI/Icon/Icon';
import ModalBody from '~/UI/Modal/Body/ModalBody';
import ModalContent from '~/UI/Modal/Content/ModalContent';
import ModalHeader from '~/UI/Modal/Header/ModalHeader';
import modalMiniStyles from '~/UI/Modal/mini.less';
import Modal from '~/UI/Modal/Modal';
import radioMenuStyles from '~/UI/Radio/menu.less';
import Radio from '~/UI/Radio/Radio';

interface Props {
	group: UserProductGroup;
	onChange(value: string): void;
	onClose(): void;
}

export default class SettingsModal extends Component<Props> {
	handleChange(value: string) {
		this.props.onChange(value);
	}

	render() {
		const { group, onClose } = this.props;
		const options = [
			{ value: FREQUENCY_IMMEDIATE, label: 'Immediate' },
			{ value: FREQUENCY_WEEKLY, label: 'Weekly' },
			{ value: FREQUENCY_MONTHLY, label: 'Monthly' },
			{ value: FREQUENCY_DISABLED, label: 'Never' },
		];

		return (
			<Modal closeButtonIcon={<Icon name='modal-close-small'>close</Icon>} styles={modalMiniStyles} onClose={onClose}>
				<ModalContent>
					<ModalHeader>
						<Heading level={4}>Notification settings for: {group.name}</Heading>
					</ModalHeader>
					<ModalBody>
						{options.map((option) => (
							<Radio
								checked={option.value === group.notification.settings.frequency}
								id={option.value}
								key={option.value}
								name='frequency'
								styles={radioMenuStyles}
								onChange={() => this.handleChange(option.value)}
							>
								{option.label}
							</Radio>
						))}
					</ModalBody>
				</ModalContent>
			</Modal>
		);
	}
}
